module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-height": "600px"
    }
  }, [_c('navbar'), _vm._v(" "), _c('info'), _vm._v(" "), _c('gallery', {
    attrs: {
      "id": "Dashboard",
      "isTop": !_vm.boolTop
    }
  }), _vm._v(" "), _c('projects'), _vm._v(" "), _c('contact'), _vm._v(" "), _c('footerBox')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39ecc8c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 695
// module chunks = 0